import { createSelector } from 'reselect';

export const getComponentState = state => state.nrcEditor;

export const getTemplateCode = createSelector(
    getComponentState,
    (state) => state.templateCode
);
export const getQuantity = createSelector(
    getComponentState,
    (state) => state.variables.quantity
);
export const getItem = createSelector(
    getComponentState,
    (state) => state.item
);
export const getFetching = createSelector(
    getComponentState,
    (state) => state.fetching
);
export const getAddingToCart = createSelector(
    getComponentState,
    (state) => state.addingToCart
);
export const getNotes = createSelector(
    getComponentState,
    (state) => state.variables.notes
);
export const getImage = createSelector(
    getComponentState,
    (state) => state.variables.image
);
export const getProduct = createSelector(
    getComponentState,
    (state) => state.variables.product
);
export const getIsFavorite = createSelector(
    getComponentState,
    (state) => state.isFavorite
);
export const getAddingFavorite = createSelector(
    getComponentState,
    (state) => state.addingFavorite
);
export const getCheckingFavorite = createSelector(
    getComponentState,
    (state) => state.checkingFavorite
);
export const getSavingWork = createSelector(
    getComponentState,
    (state) => state.savingWork
);
export const getAction = createSelector(
    getComponentState,
    (state) => state.action
);